/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {parse as qsParse} from 'query-string'
import Loader from "../common/Loader";
import {Routes} from "../utils/Routes";
import * as SecurityActions from '../security/SecurityActions';
import {bindActionCreators} from "redux";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {getCurrentLanguage} from "../utils/Helpers";

class Auth extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    componentDidMount(){
        this.parseCode()
    }

    changeLanguageLocal(lang) {
        localStorage.setItem('lang', lang);
    }

    parseCode() {
        const parsed = qsParse(this.props.location.search)
        this.props.SecurityActions.exchangeAccessCode(parsed.code).then((profile) => {
                if (profile) {
                    const flagHDA = userHasActivity(profile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? '_hda' : ''
                    if (getCurrentLanguage() !== profile.languageCode + flagHDA) {
                        this.changeLanguageLocal(profile.languageCode + flagHDA)
                        // delay the page reload to ensure app is fully rendered (prevents from logging out)
                        window.setTimeout(() => window.location.reload(), 1000)
                    }
                    this.props.history.push(Routes.HOME)
                }
            }
        ).catch(() => {
            this.props.history.push(Routes.LOGIN)
        })
    }

    render() {
        return <Loader text="Signing in" loading={this.state.loading}/>
    }
}

const mapStateToProps= state => {
    return {
        security: state.security,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth))